export default __webpack_public_path__ + "static/media/jaredprofile.f71e47c8.jpg";